import { call, put, takeLatest } from "redux-saga/effects";
import { qbApiStart, qbApiSuccess, qbApiFailure } from "./quickBooksSlice";
import { quickBooksApi } from "./quickBooksApi";
import { showToast } from "../../../components";

function* handleQuickBooksApi(action) {
  try {
    const { suppressToast = false, ...payload } = action.payload;
    const res = yield call(quickBooksApi, action.payload);
    if (res?.data) {
      console.log("response on success", res);
      yield put(qbApiSuccess({ ...res.data, meta: action.payload }));
    } else {
      // console.log("response on error", res);
      if (!suppressToast) showToast(`${res?.error}`, "error", 3000);
      yield put(qbApiFailure(res?.error || "Unknown error"));
    }
  } catch (err) {
    yield put(qbApiFailure(err.message));
  }
}

export function* watchQuickBooksApi() {
  yield takeLatest(qbApiStart.type, handleQuickBooksApi);
}
